import React from 'react';
import { createRoot } from 'react-dom/client';
import {
    createHashRouter,
    RouterProvider,
  } from "react-router-dom";
import List from "./components/list";
import Detail from "./components/detail";
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './localisation/en.json';
import translationDe from './localisation/de.json';
import translationEs from './localisation/es.json';
import translationFr from './localisation/fr.json';
import { store } from './store/store'
import { Provider } from 'react-redux'

var language = document.querySelector('html')?.getAttribute('lang')?.substring(0, 2) || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: translationEN,
      },
      de: {
        translation: translationDe,
      },
      es: {
        translation: translationEs,
      },
      fr: {
        translation: translationFr,
      },
    },
    lng: language,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

const router = createHashRouter([
    {
      path: "/",
      element: <List/>,
    },
    {
      path: "/detail/:slug/:class?/:frequency?",
      element: <Detail/>,
    },
]);

const root = createRoot(document.getElementById('filter-app'));
root.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>
);